import React from 'react';
import { Button } from './Button';

interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

/** 1-based pagination footer. `total` is the total number of records. */
export function Pagination({ page, pageSize, total, onPageChange, disabled }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className="flex items-center justify-between px-4 py-2.5" aria-label="Pagination">
      <p className="text-xs text-muted">{total === 0 ? 'No results' : `Showing ${from}–${to} of ${total}`}</p>
      <div className="flex items-center gap-2">
        <Button variant="secondary" size="sm" disabled={disabled || page <= 1} onClick={() => onPageChange(page - 1)}>‹ Prev</Button>
        <span className="text-xs text-muted" aria-live="polite">Page {page} of {totalPages}</span>
        <Button variant="secondary" size="sm" disabled={disabled || page >= totalPages} onClick={() => onPageChange(page + 1)}>Next ›</Button>
      </div>
    </nav>
  );
}
